module.exports = "mutation ($id: ID!, $data: TokenUpdate!) {\n  TokenUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"